$(function() {

	// U obrázků nastavených na plavání nalevo nebo napravo
	// budeme přidávat .really-small třidu, která obnoví plavání,
	// ale jen pokud je obrázke na méně než polovinu obrazovky široký.
	//
	// A taky zrušíme ručně zadaný margin.

	var wwh = $(window).width() / 2;
	$(".obrl, .obrr").each(function() {
		var $th = $(this);
		$th.find("img").each(function() {
			if (this.complete) {
				processImage($th);	
			} else {
				$(this).on("load", function() {
					processImage($th);
				});
			}
		});
	});

	function processImage($th) {
		var thw = 0;
		var oldDisplay = $th.css("display");
		$th.css("display", "inline-block");
		thw = $th.outerWidth();
		$th.css("display", oldDisplay);
		if (thw < wwh) {
			$th.addClass("really-small");
		} else {
			$th.removeClass("really-small");
			$th.css("margin", "")
		}
	}
});